import Vue from 'vue';
import VueResource from 'vue-resource';
import store from '@/services/store.js';

Vue.use(VueResource);
//Vue.http.options.root = 'http://localhost:50290/api'

Vue.http.interceptors.push(function (request, next) {
    next(function (response) {
        if (response.status === 401) {
            var user = store.getters.getCurrentUser;
            if (user && user.roles && user.roles.lenght && user.roles.some(function (r) { return r === "Admin"; })) {
                window.location = process.env.url.manegementLogin;
            }
            else {
                window.location = process.env.url.oldAppLogin;
            }
        }
    });
});

var cmsURl = process.env.url.manegement;
var oldApp = process.env.url.oldApp;
//oldApp = "http://localhost:3900";//it need when use old app , and call webservices locally from localhost IIS

export default class ResourceSvc {
    //general
    getBillingDataForUser = (controller) => { return Vue.http.get('/api/' + controller + '/GetBillingAddressData'); };
    createPaymentUrl = (controller, body) => { return Vue.http.post('/api/' + controller + '/CreatePaymentUrl', body); };

    //get course
    getCourses = (params) => { return Vue.http.get('/api/Course/All', { params: params }); };
    getCourseTypes = (params) => { return Vue.http.get('/api/Course/GetCourseTypes/', { params: params }); };
    getCourseById = (conf) => { return Vue.http.get('/api/Course/GetCourseById/' + conf); };
    getCourseAttendants = (params) => { return Vue.http.get('/api/Course/GetCourseAttendants/', { params: params }); };
    getCourseAttendancesAnswers = (params) => { return Vue.http.get('/api/Course/GetCourseAttendancesAnswers/', { params: params }); };
    getAttendancesForSearch = (params) => { return Vue.http.get('/api/Course/GetAttendancesForSearch/', { params: params }); };
    getMailingHistory = (params) => { return Vue.http.get('/api/Course/GetMailingHistory/', { params: params }); };
    getCourseForUser = (params) => { return Vue.http.get('/api/UserCourse/GetCourseById/' + params); };
    getCourseApplicationDetailsForUser = (params1, params2) => { return Vue.http.get('/api/UserCourse/GetCourseApplicationDetailsById/' + params1 + "/" + params2); };
    getCourseApplicationStatusForUser = (params) => { return Vue.http.get('/api/UserCourse/GetCourseApplicationStatusForUser/' + params); };

    getCourseAttendanceInfo = (id) => { return Vue.http.get('/api/Course/GetCourseAttendantsExportInfo?id=' + id); };

    //START User API
    userAPI = {
        getCourses: (params) => { return Vue.http.get('/api/UserCourse/All', { params: params }); },
        getCourseTypes: (params) => { return Vue.http.get('/api/UserCourse/GetCourseTypes', { params: params }); }
    }

    //courses coupons
    getCourseCouponCodesList = (params) => { return Vue.http.get('/api/CouponCode/GetCourseCouponCodesList/' + params); };
    addOrUpdateCourseCouponCode = (body) => { return Vue.http.post('/api/CouponCode/AddOrUpdateCourseCouponCode/', body); };
    deleteCourseCouponCode = (id) => { return Vue.http.get('/api/CouponCode/DeleteCourseCouponCode/' + id); };
    validateCourseCouponCode = (id, code) => { return Vue.http.get('/api/UserCourse/ValidateCouponCode/' + id + "/" + code); };

    //post course
    saveCourse = (data) => { return Vue.http.post('/api/Course/AddOrUpdateCourse', data); };
    deleteCourseType = (id) => { return Vue.http.delete('/api/Course/DeleteCourseType/', { params: { id: id } }); }
    addCourseType = (body) => { return Vue.http.post('/api/Course/AddCourseType', body); }
    updateCourseType = (body) => { return Vue.http.post('/api/Course/UpdateCourseType', body); }
    sendEmailToAllCourseAttendants = (body) => { return Vue.http.post('/api/Course/SendEmailToAllCourseAttendants/', body); };
    addNewAttendance = (body) => { return Vue.http.post('/api/UserCourse/AddNewAttendance', body); };

    //user
    getCurrentUserShotInfo = () => { return Vue.http.get('/api/User/CurrentShotInfo/'); };
    updateRegistrationStatus = (params) => { return Vue.http.get('/api/Course/UpdateRegistrationStatus?userId=' + params.userId + "&courseId=" + params.courseId + "&newStatus=" + params.newStatus); };
    getMapCoordinates = (params) => { return Vue.http.get('/api/Course/GetCoordinates/' + courseId) };
    saveMapCoordinates = (params) => { return Vue.http.post('/api/Course/SaveCoordinates/', params); };

    //coupons
    getCouponCodesList = (params) => { return Vue.http.get('/api/CouponCode/GetCouponCodesList/', { params: params }); };
    addOrUpdateCouponCode = (body) => { return Vue.http.post('/api/CouponCode/AddOrUpdateCouponCode/', body); };
    deleteCouponCode = (id) => { return Vue.http.get('/api/CouponCode/DeleteCouponCode/' + id); };

    //payment
    getPayments = params => { return Vue.http.get('/api/Payment/GetPaymentsList', { params: params }); }
    getRefunds = params => { return Vue.http.get('/api/Payment/GetRefundsList', { params: params }); }
    processRefund = params => { return Vue.http.get('/api/Payment/ProcessRefund' + params); }
    getRefundInformation = params => { return Vue.http.get('/api/Payment/GetRefundInformation' + params); }
    getFullTransaction = params => { return Vue.http.get('/api/Payment/GetFullTransaction', { params: params }); }
    changeRegistrationAndPaymentStatus = params => { return Vue.http.get('/api/Payment/ChangeRegistrationAndPaymentStatus' + params); }

    //member
    generateMembersList = params => { return Vue.http.post('/api/Admin/Member/GenerateMembersList', params); }
    markAsReIssued = params => { return Vue.http.post('/api/Admin/Member/MarkAsReIssued', params); }
    generateMembersListV2 = params => { return Vue.http.post('/api/Admin/Member/GenerateMembersListV2', params); }
    markAsReIssuedV2 = params => { return Vue.http.post('/api/Admin/Member/MarkAsReIssuedV2', params); }
    updateSponsorsByUserId = (params) => { return Vue.http.get('/api/Admin/Member/UpdateSponsorsByUserId', { params: params }); };

    //admin
    getClubMebershipTypes = (params) => { return Vue.http.get('/api/Admin/Club/GetClubMebershipTypes', { params: params }); }
    getClubMebershipTypeClubs = (params) => { return Vue.http.get('/api/Admin/Club/GetClubMebershipTypeClubs', { params: params }); }
    getAllClubsForCurrentActiveYear = (id) => { return Vue.http.get('/api/Admin/Club/getAllClubsForCurrentActiveYear?exceptClubMembershipTypeId=' + id); }
    deleteClubMembershipTypeFromClubAsync = (lookupId, acknowledgedRemovals = false) => { return Vue.http.post('/api/Admin/Club/DeleteClubMembershipTypeFromClub?lookupId=' + lookupId + "&acknowledgedRemovals=" + acknowledgedRemovals); }
    saveClubMembershipTypeForClub = (params) => { return Vue.http.post('/api/Admin/Club/SaveClubMembershipTypeForClub', params); }
    saveClubMembershipType = (params, acknowledgedRemovals = false) => { return Vue.http.post(`/api/Admin/Club/SaveClubMembershipType?acknowledgedRemovals=${acknowledgedRemovals}`, params); }
    getClubMembershipTypesReport = () => { return Vue.http.get('/api/Admin/Club/GetClubMembershipTypesReport') }

    getInitSeriesSettings = () => { return Vue.http.get('/api/Admin/Ranking/InitSeriesSettings'); }
    getRacesByYearAndSerieType = (type, year) => { return Vue.http.get(`/api/Admin/Ranking/GetRacesByYearAndSerieType?type=${type}&year=${year}`); }
    setSerieTypeForRace = (type, raceId, previousType) => { return Vue.http.get(`/api/Admin/Ranking/SetSerieTypeForRace?type=${type}&raceId=${raceId}&previousType=${previousType}`); }
    getRacesExceptSerieType = (type, year) => { return Vue.http.get(`/api/Admin/Ranking/GetRacesExceptSerieType?type=${type}&year=${year}`); }
    postUploadRaceResults = (data, raceId, isPreview) => { return Vue.http.post(`/api/Admin/Ranking/UploadRaceResults?raceId=${raceId}&isPreview=${isPreview}`, data); }
    deleteRaceResults = (raceId) => { return Vue.http.delete(`/api/Admin/Ranking/DeleteResultsForRace?raceId=${raceId}`); }
    getRaceResults = (raceId) => { return Vue.http.get(`/api/Admin/Ranking/GetRaceResults?raceId=${raceId}`); }
    getOldRankingRaceResults = (raceId, andSave) => { return Vue.http.get(`/api/Admin/Ranking/GetOldRankingRaceResults?raceId=${raceId}&andSave=${andSave}`); }
    postSwitchIsNationalChampionship = (raceId) => { return Vue.http.post(`/api/Admin/Ranking/PostSwitchIsNationalChampionship?raceId=${raceId}`); }
    getReCalculateAndSaveRaceResults = (raceId) => { return Vue.http.get(`/api/Admin/Ranking/ReCalculateAndSaveRaceResults?raceId=${raceId}`); }

    postCopyResultsForYearAndSerie = (year, type) => { return Vue.http.post(`/api/Admin/Ranking/CopyResultsForYearAndSerie?year=${year}&type=${type}`); }
    postCopyResultsForClubSeries = (year) => { return Vue.http.post(`/api/Admin/Ranking/CopyResultsForClubSeries?year=${year}`); }

    deleteClearRankingResults = (year, type) => { return Vue.http.delete(`/api/Admin/Ranking/ClearRankingResults?year=${year}&type=${type}`); }
    deleteClearRacesFromSerie = (year, type) => { return Vue.http.delete(`/api/Admin/Ranking/ClearRacesFromSerie?year=${year}&type=${type}`); }

    getChangePhysicalCardStatus = (userId, isPhysicalCard) => { return Vue.http.get('/api/UserMembership/ChangePhysicalCardStatus', { params: { userId: userId, isPhysicalCard: isPhysicalCard } }); }

    getRacesList = (filter) => { return Vue.http.post('/api/Admin/Race/FilterList', filter); }
    getRaceDetailsByOptions = (filter) => { return Vue.http.post('/api/Admin/Race/RaceDetailsByOptions', filter); }
    getExportRacesList = (filter) => { return Vue.http.post('/api/Admin/Race/ExportList', filter); }
    //dashboard

    //profile
    registerUser = (data) => { return Vue.http.post('/api/user/Register', data); }
    changeUserPassword = (login) => { return Vue.http.post('/api/user/ChangePassword', login); }
    confirmChangeUserPassword = (params) => { return Vue.http.get('/api/user/ConfirmResetPassword', { params: params }); }
    getProfileInfo = (params) => { return Vue.http.get('/api/Profile/GetProfileInfo', { params: params }); }
    saveProfileInfo = (data) => { return Vue.http.post('/api/Profile/SaveProfileInfo', data); };
    getCurrentServerYear = () => { return Vue.http.get('/api/token/GetYear'); }

    //card
    getProfilePrimaryInfo = (params) => { return Vue.http.get('/api/Profile/GetProfilePrimaryInfo', { params: params }); };
    updateProfileImage = (data) => { return Vue.http.post('/api/Profile/UpdateProfileImage', data); };

    //membership
    getMembershipUpgradeInfo = (id) => { return Vue.http.get('/api/Membership/GetMembershipUpgradeInfo?userId=' + id); };
    prepareMembershipRegistration = (params) => { return Vue.http.get('/api/UserMembership/PrepareMembershipRegistration', { params: params }); };
    changeMainClub = (currentYearId, nextYearId, userId) => { return Vue.http.post('/api/UserMembership/changeMainClub?mainClubCurrentYear=' + currentYearId + '&mainClubNextYear=' + nextYearId + '&userId=' + userId); };
    getFile = (params) => { return Vue.http.get('/api/Membership/GetFile', { params: params }); };
    joinAdultToClub = (params) => { return Vue.http.get('/api/UserMembership/JoinAdultToClub', { params: params }); };

    markUserCardForReissue = () => { return Vue.http.post('/api/Membership/markUserCardForReissue') };
    isUserMarkedCardForReissue = () => { return Vue.http.get('/api/Membership/isUserMarkedCardForReissue') };

    // recurring membership payment
    disableTiAutoRenewal = (paymentId) => { return Vue.http.delete(`/api/RecurringMembershipPayment/${paymentId}`); };
    disableClubAutoRenewal = (membershipId) => { return Vue.http.delete(`/api/ClubAutoRenewal/${membershipId}`); };
    getRenewalOptInEligibility = () => { return Vue.http.get('/api/UserMembership/GetRenewalOptInEligibility'); };
    submitRenewalOptIn = (body) => { return Vue.http.post('/api/UserMembership/SaveRenewalOptIn', body); };
    submitCampaignRenewalOptIn = (body) => { return Vue.http.post('/api/UserMembership/SaveCampaignRenewalOptIn', body); };
    getRenewalManagement = () => { return Vue.http.get('/api/UserMembership/GetRenewalManagement'); };

    //basket
    getBasketDetails = () => { return Vue.http.get('/api/UserMembership/GetBasketDetails'); };
    deleteAllBasketDetails = () => { return Vue.http.delete('/api/UserMembership/ClearBasketDetails'); };
    deleteBasketItemByUserId = (paidByUserId, itemId) => { return Vue.http.delete(`/api/UserMembership/DeleteBasketItemByUserId?userId=${paidByUserId}&itemId=${itemId}`); };

    //races
    getRegistrationsForRaceList = (query) => { return Vue.http.get('/api/Race/GetRegistrationsForRaceList' + query); }
    getRacesRegistrations = (params) => { return Vue.http.get('/api/Race/GetRacesRegistrations', { params: params }); }
    getRacesTransfersRegistrations = (params) => { return Vue.http.get('/api/Race/GetRacesTransfersRegistrations', { params: params }); }
    getRacesManagedByUser = () => { return Vue.http.get('/api/Race/GetRacesManagedByUser'); }
    getRacesWhereUserIsOfficer = () => { return Vue.http.get('/api/Race/getRacesWhereUserIsOfficer'); }

    getRaceDetails = (id, sdrId, copyRaceId, isAdminRequest, isViewOnly) => { return Vue.http.get(`/api/Race/GetRaceDetails?raceId=${id}&sdrId=${sdrId}&copyRaceId=${copyRaceId}&isAdminRequest=${isAdminRequest}&isViewOnly=${isViewOnly}`); }
    postSaveRaceDetails = (id, sdrId, stage, body) => { return Vue.http.post(`/api/Race/SaveRaceDetails?raceId=${id}&sdrId=${sdrId}&stage=${stage}`, body); }
    getValidateRaceCategoryAndReturnSimpleUser = (userTiId, category) => { return Vue.http.get(`/api/Race/ValidateRaceCategoryAndReturnSimpleUser?userTiId=${userTiId}&category=${category}`); }
    deleteRemoveRace = (raceId) => { return Vue.http.delete(`/api/Race/RemoveRace?raceId=${raceId}`); }
    postSaveRaceEstimateTimes = (id, estimatedRunTime, estimatedSwimTime, estimatedBikeTime) => { return Vue.http.post(`/api/Race/SaveRaceEstimateTimes?raceRegistrationId=${id}&estimatedRunTime=${estimatedRunTime}&estimatedSwimTime=${estimatedSwimTime}&estimatedBikeTime=${estimatedBikeTime}`); }
    postPrepareSanctioningFeeTempData = (raceId) => { return Vue.http.post(`/api/Race/PrepareSanctioningFeeTempData?raceId=${raceId}`); }

    setRaceAdmins = (raceId, isAdminRequest, body) => { return Vue.http.post(`/api/Race/SetRaceAdmins?raceId=${raceId}&isAdminRequest=${isAdminRequest}`, body) };
    getRaceAdmins = (raceId, isAdminRequest) => { return Vue.http.get(`/api/Race/GetRaceAdmins?raceId=${raceId}&isAdminRequest=${isAdminRequest}`) };
    getMemberByLoginOrTiID = (query) => { return Vue.http.get(`/api/Member/GetMemberByLoginOrTiID?query=${query}`) };

    getRaceOfficers = (raceId) => { return Vue.http.get(`/api/admin/Race/GetRaceOfficers?raceId=${raceId}`) };
    setRaceOfficers = (raceId, officers) => { return Vue.http.post(`/api/admin/Race/SetRaceOfficers?raceId=${raceId}`, officers) };

    //clubs
    getClubsManagedByUser = () => { return Vue.http.get('/api/Profile/GetClubsManagedByUser'); }
    getClubsManagedByRemovalOfficers = () => { return Vue.http.get('/api/Club/GetClubsManagedByRemovalOfficers'); }
    getClubMembers = (clubId, year) => { return Vue.http.get('/api/Club/GetClubMembers?clubId=' + clubId + (year ? '&year=' + year : '')); }
    toggleMemberFlag = (memberId, clubId, flag, year) => { return Vue.http.post('/api/Club/ToggleMemberFlag?memberId=' + memberId + '&clubId=' + clubId + '&flag=' + flag + (year ? '&year=' + year : '')); }
    removeClubMember = (memberId, clubId, year) => { return Vue.http.delete('/api/Club/RemoveMemberFromClub?memberId=' + memberId + '&clubId=' + clubId + (year ? '&year=' + year : '')); }
    prepareClubAffilation = (id) => { return Vue.http.get('/api/UserClub/PrepareClubAffilation?clubId=' + id); }
    prepareClubAffiliationPayment = (clubId) => { return Vue.http.get('/api/UserClub/PrepareClubAffilation?clubId=' + clubId); }
    removeClubAsAdmin = (id, year, acknowledged = false) => { return Vue.http.delete('/api/UserClub/RemoveClubAsAdmin?clubId=' + id + '&year=' + year + '&acknowledged=' + acknowledged); }
    getClubsListByFilter = (isJunior, selectedCounty) => { return Vue.http.get(`/api/UserClub/getClubsList?isJunior=${isJunior}&selectedCounty=${selectedCounty}`); }
    
    // club registration
    saveClubRegistration = (data) => { return Vue.http.post('/api/ClubRegistration/SaveClub', data); }
    reaffiliateClub = (data) => { return Vue.http.post('/api/ClubRegistration/ReaffiliateClub', data); }
    updateClubRegistration = (data) => { return Vue.http.put('/api/ClubRegistration/UpdateClub', data); }
    getAllMembershipTypes = () => { return Vue.http.get('/api/ClubRegistration/GetAllMembershipTypes'); }
    getClubMembershipTypes = (clubId, year) => { return Vue.http.get(`/api/ClubRegistration/GetClubMembershipTypes?clubId=${clubId}${year ? '&year=' + year : ''}`); }
    getPreviousYearClubs = () => { return Vue.http.get('/api/ClubRegistration/GetPreviousYearClubs'); }
    getClubRenewalOptInLockState = () => { return Vue.http.get('/api/ClubRegistration/GetClubRenewalOptInLockState'); }
    getClubDetailsForCopy = (clubId, year) => { return Vue.http.get(`/api/ClubRegistration/GetClubDetailsById/${clubId}${year ? '?year=' + year : ''}`); }
    getClubFile = (clubId, fileType, year) => { return Vue.http.get(`/api/ClubRegistration/GetClubFile?clubId=${clubId}&fileType=${fileType}${year ? '&year=' + year : ''}`); }
    getClubFileMetadata = (clubId, fileType, year) => { return Vue.http.get(`/api/ClubRegistration/GetClubFileMetadata?clubId=${clubId}&fileType=${fileType}${year ? '&year=' + year : ''}`); }
    uploadClubConstitution = (clubId, data, year) => { return Vue.http.post(`/api/ClubRegistration/UploadClubConstitution?clubId=${clubId}${year ? '&year=' + year : ''}`, data); }
    updateClubMembershipTypes = (clubId, data, acknowledgedRemovals = false) => { return Vue.http.put(`/api/ClubRegistration/UpdateClubMembershipTypes?clubId=${clubId}&acknowledgedRemovals=${acknowledgedRemovals}`, data); }

    //junior
    upgradeJuniorToAdult = (data) => { return Vue.http.post('/api/Profile/UpgradeJuniorToAdult', data); }

    //ranking
    rankingInitSeriesSettings = () => { return Vue.http.get('/api/Ranking/InitSeriesSettings'); }
    rankingGetRaces = (query) => { return Vue.http.get('/api/Ranking/GetRaces?' + query); }
    rankingGetClubs = (query) => { return Vue.http.get('/api/Ranking/GetClubs?' + query); }
    rankingGetSeries = (query) => { return Vue.http.get('/api/Ranking/GetSeries?' + query); }
    rankingGetSeriesForClub = (query) => { return Vue.http.get('/api/Ranking/GetSeriesForClub?' + query); }
    rankingGetRaceResult = (query) => { return Vue.http.get('/api/Ranking/GetRaceResult?' + query); }
    rankingGetSeriesRacesForUser = (query) => { return Vue.http.get('/api/Ranking/GetSeriesRacesForUser?' + query); }

    //race calendar
    raceCalendarList = (filter) => { return Vue.http.post('/api/RaceEntry/GetRaceCalendarList', filter); }
    raceCalendarExpandInfo = (id) => { return Vue.http.get('/api/RaceEntry/GetRaceCalendarExpandInfo?raceId=' + id); }
    raceCalendarCardInfo = (id) => { return Vue.http.get('/api/RaceEntry/GetRaceCalendarCardInfo?raceId=' + id); }

    //club standards
    getClubStandardQuestions = (clubId) => { return Vue.http.get('/api/ClubStandard/Get?clubId=' + clubId); }
    getClubStandardQuestionsWithType = (clubId, standardType) => { return Vue.http.get('/api/admin/ClubStandard/Get?clubId=' + clubId + "&standardType=" + standardType); }
    postSaveClubStandardAnswers = (clubId, blockId, data) => { return Vue.http.post(`/api/ClubStandard/Set?clubId=${clubId}&blockId=${blockId}`, data); }
    postSaveClubStandardAnswersAdmin = (clubId, blockId, data) => { return Vue.http.post(`/api/admin/ClubStandard/Set?clubId=${clubId}&blockId=${blockId}`, data); }
    getClubStandardFileById = (id) => { return Vue.http.get('/api/admin/ClubStandard/GetClubStandardFileById/' + id); };

    getClubStandardQuestionsList = (filter) => {
        return Vue.http.get(`/api/admin/ClubStandard/List?isNeedSupportData=${filter.isNeedSupportData
            }&clubName=${filter.clubName
            }&year=${filter.year
            }&blockStatus=${filter.blockStatus
            }&standardType=${filter.standardType
            }&options.take=${filter.options.take
            }&options.skip=${filter.options.skip
            }`);
    }

    postUpdateStatus = (body) => { return Vue.http.post('/api/admin/ClubStandard/UpdateStatus', body); }

    getClubsList = (query) => { return Vue.http.get('/api/admin/Club/List' + query); }
    getAdminClubsList = (query) => { return Vue.http.get('/api/Admin/Club/ManageList' + query); }
    updateStandardType = (clubId, newTypeId) => { return Vue.http.post('/api/admin/Club/UpdateStandardType?clubId=' + clubId + "&standardType=" + newTypeId); }
    getAdminClubDetail = (clubId, year) => { return Vue.http.get('/api/Admin/Club/GetClubDetail?clubId=' + clubId + (year != null ? '&year=' + year : '')); }
    saveAdminClub = (data) => { return Vue.http.post('/api/Admin/Club/SaveClub', data); }
    createAdminClub = (data) => { return Vue.http.post('/api/Admin/Club/CreateClub', data); }
    deleteAdminClub = (clubId, year, acknowledged = false) => { return Vue.http.post('/api/Admin/Club/DeleteClub?clubId=' + clubId + '&year=' + year + '&acknowledged=' + acknowledged); }
    getClubMemberPreview = (userId, clubId) => { return Vue.http.get(`/api/Admin/Club/GetClubMemberPreview?userId=${userId}&clubId=${clubId}`); }
    getDefaultAdminTiNumbers = () => { return Vue.http.get('/api/Admin/Club/GetDefaultAdminTiNumbers'); }
    getAdminFile = (id) => { return Vue.http.get('/api/Admin/File/Download?id=' + id); }


    updateOfficerStatus = (body) => { return Vue.http.post('/api/race/updateOfficerStatus', body); }
    getDefaultEmails = (raceId) => { return Vue.http.get(`/api/admin/race/getDefaultEmails?raceId=${raceId}`); }
    sendRaceEmail = (raceId, body) => { return Vue.http.post(`/api/admin/race/sendEmail?raceId=${raceId}`, body); }
    getMerchandisesPerUserForRaceList = (raceId) => { return Vue.http.get(`/api/race/GetMerchandisesPerUserForRaceList?raceId=${raceId}`); }

    getCoupons = (raceId) => { return Vue.http.get(`/api/race/GetCoupons?raceId=${raceId}`); }
    addOrUpdateCoupons = (raceId, body) => { return Vue.http.post(`/api/race/AddOrUpdateCoupons?raceId=${raceId}`, body); }

    getRaceAvailabilityForUser = (json) => { return Vue.http.post(cmsURl + '/Triathlon/WebServices/RaceSimpleService.asmx/GetRaceAvailabilty', json); };
    setRaceAddOdmForUser = (json) => { return Vue.http.post(cmsURl + '/Triathlon/WebServices/RaceSimpleService.asmx/Add_ODM', json); };

    //race entry from old module
    getEnvironmentProperties = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/GetEnvironmentProperties', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getUserRegistrationList = () => { return Vue.http.get(`/api/UserRace/GetUserRegistrationList`); }

    //Obsolete
    getJuniorAccountList = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/UserService.asmx/GetJuniorAccountList', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getCartNew = (params) => { return Vue.http.get('/api/UserRace/GetCart', { params: params }); };

    //Obsolete
    getCart = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/GetCart', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    //Obsolete
    getRaceDetailCMS = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/GetRaceDetail', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    //Obsolete
    saveRaceRegistration = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/SaveItem', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };


    proceedToRacePaymentOld = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/ProceedToRacePayment', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getRacesCMS = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/GetRaces', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    addCouponsOld = (json, cookies) => {//json: "["test"]"
        return Vue.http.post(oldApp + '/webservices/RaceEntryService.asmx/AddCoupons', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getEnvironmentForUser = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceOdlService.asmx/GetEnvironmentForUser', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    addODMForExternalRace = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceOdlService.asmx/AddODMForExternalRace', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    saveOdmItem = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceOdlService.asmx/SaveItem', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getOdlSessionItem = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceOdlService.asmx/GetSessionItem', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    proceedToPaymentOdlCMS = (json, cookies) => {
        return Vue.http.post(oldApp + '/webservices/RaceOdlService.asmx/ProceedToPayment', json, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getDetailsConfirmed = (guid, cookies) => {
        return Vue.http.get(oldApp + `/membership/RaceOdl.aspx?cmd=DetailsConfirmed&guid=${guid}`, {
            credentials: "same-origin",
            cookie: cookies
        });
    };

    getCookies = () => { return Vue.http.get('/api/RaceEntry/GetCookies'); }

    //User Race controller
    prepareRaceEntryTempData = (raceId, openingId, isProceedToPayment = true) => { return Vue.http.get(`/api/UserRace/PrepareRaceEntryTempData/${raceId}/${openingId}/${isProceedToPayment}`) };
    checkTransferAvailability = (loadedUserId, userTransferId, raceId) => { return Vue.http.get(`/api/UserRace/CheckTransferAvailability?loadedUserId=${loadedUserId}&userTransferId=${userTransferId}&raceId=${raceId}`); };
    doRaceTransfer = (userTiId, raceId, raceOpeningId, currentRaceRegistrationId) => { return Vue.http.post(`/api/UserRace/PrepareRaceTransfer?userTiId=${userTiId}&raceId=${raceId}&raceOpeningId=${raceOpeningId}&currentRaceRegistrationId=${currentRaceRegistrationId}`); };
    postAcceptRaceTransfer = (body) => { return Vue.http.post(`/api/UserRace/AcceptRaceTransfer`, body); };
    cancelRaceTransfer = (currentRaceRegistrationId) => { return Vue.http.delete(`/api/UserRace/CancelRaceTransfer?currentRaceRegistrationId=${currentRaceRegistrationId}`); };
    removeMerchFromCart = (id) => { return Vue.http.delete(`/api/UserRace/RemoveMerchFromCart?id=${id}`); };
    getRelayTypeList = () => { return Vue.http.get(`/api/RaceEntry/GetRelayTypeList`); };
    getRacePurchaseSubTypeList = () => { return Vue.http.get(`/api/RaceEntry/GetRacePurchaseSubTypeList`); };
    addCoupons = (body) => { return Vue.http.post(`/api/UserRace/AddCoupons`, body); };
    resetCart = () => { return Vue.http.delete(`/api/UserRace/resetCart`); };
    getRacesCMSnew = (body) => { return Vue.http.post(`/api/UserRace/GetRacesCMS`, body) };
    getRaceDetailForUser = (body) => { return Vue.http.post(`/api/UserRace/GetRaceDetail`, body); };
    saveRaceRegistrationNew = (body) => { return Vue.http.post('/api/UserRace/SaveRaceEntry', body); };
    removeRegistrationFromCart = (id) => { return Vue.http.delete(`/api/UserRace/RemoveRegistrationFromCart?id=${id}`); };

}



// WEBPACK FOOTER //
// ./src/services/resource.svc.js